import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, SPACE } from '@/nova/theme/tokens';

export const Chip = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[8]};
  width: 100%;
  box-sizing: border-box;
  padding: ${SPACE[8]} ${SPACE[12]};
  border-radius: 999px;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceCard};
`;

/* The art styles listing's 18+ tag, inline. */
export const Mark = styled(Text)`
  flex: none;
  padding: ${SPACE[2]} ${SPACE[8]};
  border-radius: 999px;
  border: 1px solid ${COLORS.hairline};
  color: ${COLORS.danger};
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
`;

export const Copy = styled(Text)`
  min-width: 0;
  font-size: 13px;
  line-height: 1.4;
  color: ${COLORS.textMuted};
`;
